import { api } from './api';

export interface DashboardSnapshot {
  workspaceId: string;
  scenarios: string[];
  accountCount: number;
  totalFacts: number;
  topAccounts: {
    account_code: string;
    scenario: string;
    total: number;
    points: { period_start: string; amount: number }[];
    /** IDs of the fp_facts behind this number (capped) — powers drill-through. */
    fact_ids?: string[];
  }[];
  totalsByPeriod: { period_start: string; scenario: string; amount: number }[];
  /** FX translation context — every amount above is in `reportingCurrency`. */
  fx: {
    reportingCurrency: string;
    ratesUsed: { from: string; to: string; rate: number; date: string }[];
    missingRates: string[];
  };
}

export const dashboardApi = {
  async snapshot(workspaceId: string): Promise<DashboardSnapshot> {
    const r = await api.get<DashboardSnapshot>(`/api/workspaces/${workspaceId}/dashboard`);
    return r.data;
  },
};
